import { gql } from "lib/apolloClient";

export const standardsFragment = gql`
  fragment standardsFragment on PlannerElementNode {
    id
    displaySequence
    uid
    label
    subText
    gradingType
    code
    depth
    parent
    type
    # written to make consistent with unitPlanFragment
    subType
    updatedAt
    children
    dataSetNodeWrapper {
      plannerElementNodeSet {
        id
        title
      }
      properties {
        isArchived
        isPowerStandard
        weight
        subjects {
          id
          name
          # written to make consistent with unitPlanFragment
          isArchived
        }
        grades {
          id
          name
        }
        tags {
          id
          label
        }
        # written to make consistent with unitPlanFragment
        associatedPlannerElementNodes {
          id
        }
        subjectGroups {
          id
        }
      }
    }
  }
`;

export const benchmarksFragment = gql`
  fragment benchmarksFragment on PlannerBenchmark {
    id
    displaySequence
    uid
    label
    subText
    gradingType
    code
    depth
    parent
    updatedAt
    # written to make consistent with unitPlanFragment
    children
    subject
    dataSetNodeWrapper {
      standardSet {
        id
        title
      }
      properties {
        isArchived
        isPowerStandard
        weight
        grades {
          id
          name
        }
        tags {
          id
          label
        }

        subject {
          id
          name
          # written to make consistent with unitPlanFragment
          isArchived
        }
      }
    }
  }
`;
